import styled from "styled-components";

export const Container = styled.div`
  padding: 32px 20px;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.brand.muted};
`;
